import React, { useState } from 'react';
import { Row, Col, FormGroup, Input, Card, Alert, Button, CardBody, Container, Label } from 'reactstrap';
import Select from 'react-select';
import { useReportMicStatistics } from '../../../hooks/micro/useReportMicStatistics';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { ProgressBar } from 'primereact/progressbar';

export const IndexReportMicStatistics = () => {
    const {
        handleSearch, start_date, end_date, handleInputChange, isDownloading, isButtonDisabled, handleDownloadReportMicro, 
        listReport, searchTerm, setSearchTermsearchTerm, setSearchTerm

    } = useReportMicStatistics();

   const headerStyle = {
        backgroundColor: "#1d5b83",
        color: "#fff",
        fontWeight: "bold",
        fontSize: "12px",
        borderRight: "1px solid #fff",
        borderBottom: "2px solid #fff",
    };

    const cellStyle = {
        fontSize: "12px",
        padding: "5px",
        textAlign: "center",
        fontFamily: "Montserrat, sans-serif",
    };

    const accionsTemplete = (rowData) => {
            const progress = rowData.progress ?? 0;
            const isDisabled = progress < 100;
            
            const disabledStyle = {
                backgroundColor: "#d3d3d3",
                color: "#888",
                cursor: "not-allowed",
                opacity: 0.7
            };
    
            return (
                <div className="d-flex justify-content-center align-items-center" style={{ gap: "3px", marginRight: "3px" }}>
                    <button
                        size="sm"
                        disabled={isDisabled}
                        title="Descargar Reporte de positividad"
                        style={{
                            padding: "2px",
                            fontSize: "1rem",
                            height: "26px",
                            width: "26px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            border: "none",
                            borderRadius: "4px",
                            backgroundColor: "#075488",
                            color: "#fff",
                            ...(isDisabled ? disabledStyle : {})
                        }}
                        onClick={() => handleDownloadReportMicro(rowData)}
                    >
                        <i className="fa fa-download"></i>
                    </button>
    
                </div>
            );
        };


    return (
       
        <div className='container-global-zoom'>
            <Card
                style={{
                    marginBottom: '15px',
                    background: 'linear-gradient(135deg, #002940 0%, #1d5b83 100%)',
                    border: 'none',
                    boxShadow: '0 4px 12px rgba(0,0,0,0.15)'
                }}
            >
                <CardBody style={{ padding: '12px 25px' }}>
                    <div
                        className="d-flex align-items-center justify-content-center"
                        style={{ gap: '12px' }}
                    >
                        <h4
                            className="mb-0"
                            style={{
                                color: '#fff',
                                fontWeight: 700,
                                fontSize: '20px',
                                textAlign: 'center'
                            }}
                        >
                            Reporte de Positividad
                        </h4>
                    </div>
                </CardBody>
            </Card>


            <Card className="shadow-sm border height-equal pricingtable rounded-2 p-2 mb-2"
                style={{ paddingTop: "15px", paddingLeft: "15px", paddingRight: "15px", textAlign: "justify" }}>
                <Row className="justify-content-center text-center">
                    <Col sm="2">
                    <br />
                    
                    </Col>
                    <Col sm="3" className="mb-3 mt-2">
                        <Label className="f-w-600 f-12 badge badge-light-primary">Fecha de inicio <span className='f-16' style={{ color: "#0079C7" }}>*</span></Label>
                        <FormGroup>
                            <Input
                                style={{
                                    borderColor: "#4aa7e6ff",
                                    borderStyle: "solid",
                                    borderWidth: "1px",
                                    borderRadius: "15px",
                                    height: "35px",
                                    width: "100%",
                                    fontSize: "11px",
                                    textAlign: "center"
                                }}
                                type="date"
                                name="start_date"
                                value={start_date}
                                onChange={handleInputChange}
                            />
                        </FormGroup>
                    </Col>

                    <Col sm="3" className="mb-2 mt-2">
                        <Label className="f-w-600 f-12 badge badge-light-primary">Fecha Final <span className='f-16' style={{ color: "#0079C7" }}>*</span></Label>
                        <FormGroup>
                            <Input
                                style={{
                                    borderColor: "#4aa7e6ff",
                                    borderStyle: "solid",
                                    borderWidth: "1px",
                                    borderRadius: "15px",
                                    height: "35px",
                                    width: "100%",
                                    fontSize: "11px",
                                    textAlign: "center"
                                }}
                                type="date"
                                name="end_date"
                                value={end_date}
                                onChange={handleInputChange}
                            />
                        </FormGroup>
                    </Col>

                   

                    <Col sm="1" className="mb-2" style={{ top: "35px" }}>
                        <button
                            onClick={handleSearch}
                            disabled={isButtonDisabled}
                            style={{
                                backgroundColor: isDownloading ? "#f79a21ff" : "#002940",
                                color: "#fff",
                                borderRadius: "15px",
                                padding: "10px",
                                fontSize: "12px",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                gap: "8px",
                                border: "none",
                                cursor: isButtonDisabled ? "not-allowed" : "pointer"
                            }}
                        >
                            {isDownloading && <i className="fa fa-spinner fa-spin mr-1" />}
                            {isDownloading ? "Cargando....." : "Busqueda"}
                        </button>
                    </Col>

                    <Col sm="3" className="mb-2" style={{ marginTop: "40px" }}>
                        <Input
                            type="text"
                            placeholder="Busqueda por Fechas"
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                            style={{
                                borderColor: "#4aa7e6ff",
                                borderRadius: "15px",
                                height: "35px",
                                fontSize: "11px",
                                textAlign: "center"
                            }}
                        />
                    </Col>
                </Row>

                <DataTable
                    value={listReport}
                    paginator
                    rows={10}
                    responsiveLayout="scroll"
                    className="data-table p-datatable-striped p-datatable-sm"
                    rowsPerPageOptions={[10, 50, 100]}
                    emptyMessage={
                        <div className="text-center">
                            <img src={require("../../../assets/images/loginHelenLabs/dashboard/recepcionista.svg")} style={{ width: "25%" }} alt="Sin resultados" />
                            <br />
                            <p className="badge badge-light-primary mt-2" style={{ fontSize: "15px" }}>
                                Sin resultados.
                            </p>
                        </div>
                    }
                    loading={isDownloading}
                    globalFilter={searchTerm || null}
                    globalFilterFields={['from', 'to']}
                >
                    <Column body={(rowData, { rowIndex }) => rowIndex + 1} header="#" headerStyle={headerStyle} style={cellStyle} />
                    <Column field="from" header="Fecha Inicio" headerStyle={headerStyle} style={cellStyle} />
                    <Column field="to" header="Fecha Final" headerStyle={headerStyle} style={cellStyle} />
                    <Column field="report_until" header="Fecha de impresión" headerStyle={headerStyle} style={cellStyle} />
                   <Column
                    header="Proceso"
                    headerStyle={headerStyle}
                    style={cellStyle}
                    body={(rowData) => {
                        const progress = rowData.progress ?? 0;

                        if (progress >= 100) {
                            return (
                                <span
                                    style={{
                                        backgroundColor: "#28a745",
                                        color: "#fff",
                                        padding: "5px 12px",
                                        borderRadius: "12px",
                                        fontWeight: "bold",
                                        fontSize: "12px",
                                        display: "inline-block"
                                    }}
                                >
                                    Completado
                                </span>
                            );
                        }

                        return (
                            <div style={{ width: "120px", margin: "0 auto" }}>
                                <ProgressBar
                                    value={progress}
                                    showValue
                                    style={{
                                        height: "16px",
                                        borderRadius: "10px"
                                    }}
                                />
                            </div>
                        );
                    }}
                />

                <Column header="Acciones" body={accionsTemplete} headerStyle={headerStyle} style={cellStyle} />
            

                </DataTable>

               

            </Card>


        </div>       
    );
};
